import React from "react";
import { RxCross1 } from "react-icons/rx";
import { IoBagHandleOutline } from "react-icons/io5";
import { HiOutlineMinus, HiPlus } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addTocart, removeFromCart } from "../../redux/actions/cart";
import { toast } from "react-toastify";
import { setCartOpen } from "../../state/uiSlice"; 

const Cart = () => {
  const profileType = sessionStorage.getItem('currentProfile') || 'Guest'; 
  const cartState = useSelector(state => state.cart.carts); 
  const cart = cartState[profileType] || [];
  const isCartOpen = useSelector(state => state.ui.isCartOpen);
  console.log("Initial cart state from local storage:", cart);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    dispatch(setCartOpen(false));
  };

  const handlePanelClick = (event) => {
    event.stopPropagation();
  };

  const handleCheckout = () => {
    handleClose(); 
    navigate("/checkout");
  };

  const removeFromCartHandler = (data) => {
    dispatch(removeFromCart(data));
  };

  const totalPrice = cart.reduce(
    (acc, item) => acc + item.qty * item.price,
    0
  );

  const totalItems = cart.reduce((acc, item) => acc + item.qty, 0);
  

  const quantityChangeHandler = (data) => {
    dispatch(addTocart(data));
  };
  

  if (!isCartOpen) return null;

  return (
    <div className="avatar-dropdown-menu-overlay shared-right-slideout-overlay cart-sidebar-overlay" onClick={handleClose}>
      <div className="avatar-dropdown-menu-popup shared-right-slideout-popup cart-sidebar-popup" onClick={handlePanelClick}>
        <div>
          <button
            type="button"
            className="slider-tray-close-button"
            onClick={handleClose}
            aria-label="Close cart"
          >
            <RxCross1
              size={25}
              className="cart-sidebar-close-btn"
            />
          </button>
          <div className="cart-sidebar-header">
            <IoBagHandleOutline size={25} />
            <h5 className="cart-sidebar-item-count">
            {totalItems} {totalItems === 1 ? 'item' : 'items'}
            </h5>
          </div>
          <div className="cart-sidebar-items">
            {cart.length === 0 ? (
              <div className="cart-sidebar-empty">
                <h5>Cart is Empty.</h5>
              </div>
            ) : (
              <>
                {cart.map((i, index) => (
                  <CartSingle
                    key={index}
                    data={i}
                    quantityChangeHandler={quantityChangeHandler}
                    removeFromCartHandler={removeFromCartHandler}
                  />
                ))}
              </>
            )}
          </div>
          <div className="cart-sidebar-checkout">
          {cart.length === 0 ? (
              <div className="cart-sidebar-checkout-btn-disabled">
                <h1>Checkout Now (USD ${totalPrice})</h1>
              </div>
            ) : (
              <div className="cart-sidebar-checkout-btn" onClick={handleCheckout}>
                <h1>Checkout Now (USD ${totalPrice})</h1>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const CartSingle = ({ data, quantityChangeHandler, removeFromCartHandler }) => {
  const totalPrice = data.price * data.qty;

  const increment = () => {
    if (data.stock <= data.qty) {
      toast.error("Product stock limited!");
    } else {
      quantityChangeHandler({ ...data, qty: data.qty + 1 });
    }
  };

  const decrement = () => {
    if (data.qty > 1) {
      quantityChangeHandler({ ...data, qty: data.qty - 1 });
    }
  };

  const imageUrl =
    data?.variant?.image?.url ||
    (Array.isArray(data?.images) && data?.images[0]?.url) ||
    data?.image ||
    "https://via.placeholder.com/150";

  return (
    <div className="cart-sidebar-item">
      <div className="cart-sidebar-item-content">
        <div className="cart-sidebar-item-controls">
          <div className="cart-sidebar-item-control" onClick={increment}>
            <HiPlus size={16} color="36d300" />
          </div>
          <span className="cart-sidebar-item-quantity">{data.qty}</span>
          <div className="cart-sidebar-item-control" onClick={decrement}>
            <HiOutlineMinus size={16} color="var(--primary-color)" />
          </div>
        </div>
        <img src={imageUrl} alt="" className="cart-sidebar-item-image" />
        <div className="cart-sidebar-item-details">
          <h1>{data.name}</h1>
          {data.variant && (
            <h4>
              {data.variant.size && `${data.variant.size}`} 
              {data.variant.size && data.variant.color && " | "} 
              {data.variant.color && `${data.variant.color}`}
              {(data.variant.size || data.variant.color) && data.variant.customValue && " | "}
              {data.variant.customValue && `${data.variant.customValue}`}
            </h4>
          )}
          <h4>${data.price} * {data.qty}</h4>
          <h4 className="cart-sidebar-item-total-price">US ${totalPrice}</h4>
        </div>
        <RxCross1
          className="cart-sidebar-remove-item"
          onClick={() => removeFromCartHandler(data)}
        />
      </div>
    </div>
  );
};


export default Cart;
